import { gql, useLazyQuery } from "@apollo/client";
import { GetGoodQuery, GetGoodQueryVariables } from "../generated/graphql";

const GET_GOOD_QUERY = gql`
  query getGood($input: GetGoodInput!) {
    getGood(input: $input) {
      ok
      err
      good {
        id
        tags
        summary
        limitNumOrders
        title
        status
        expirydate
        goodRelations {
          id
          index
          relatedGoods {
            title
            id
          }
        }
        createdAt
        weight
        price
        discountRate
        attributeSet
        goodAttrInfo
        corporation {
          id
          name
        }
        goodOptions {
          id
          name
          desc
          isActive
          deliveryDate
          discountRate
        }
        subCategory {
          id
          name
        }
      }
    }
  }
`;

export const useGetGood = (onCompleted?: (data: GetGoodQuery) => void) => {
  return useLazyQuery<GetGoodQuery, GetGoodQueryVariables>(GET_GOOD_QUERY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
